/*
 * @Author: wangshengqiang
 * @Date: 2021-09-28 11:15:27
 * @LastEditTime: 2022-03-01 15:37:59
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useState } from 'react';
import { Popup, Cell } from 'zarm';
import './index.less';
import lookSvg from '@/assets/images/look.svg';
import { goNext } from '@/utils/navigation';
import { getHashParam, getQueryParam } from '@/utils';

const PreviewButton = props => {
  const {
    pageList = []
  } = props;
  const currentIndex = getHashParam('page') || 1; // simulate 预览环境

  const {
    mode
  } = getQueryParam();
  const [vis, setVis] = useState(false);

  const changePage = pageOrder => {
    goNext(pageOrder);
    setVis(false);
  };

  if (mode !== 'simulate') return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "cs-PreviewButton"
  }, !vis && /*#__PURE__*/React.createElement("div", {
    onClick: () => setVis(true)
  }, /*#__PURE__*/React.createElement("img", {
    className: "cs-look",
    alt: "\u67E5\u770B",
    src: lookSvg
  })), /*#__PURE__*/React.createElement(Popup, {
    visible: vis,
    onMaskClick: () => setVis(false),
    direction: "right",
    afterClose: () => {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "cs-previewbutton-conntent"
  }, pageList && pageList.map((item, index) => {
    return /*#__PURE__*/React.createElement(Cell, {
      className: index + 1 === Number(currentIndex) ? 'active' : '',
      title: item.label,
      onClick: () => {
        changePage(item.pageOrder);
      }
    });
  }))));
};

export default PreviewButton;